

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// getCustomerRewardsList
// GETCUSTOMERREWARDSLIST
const GETCUSTOMERREWARDSLIST= createAsyncThunk(
  "getCustomerRewardsList/getCustomerRewardsList",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getCustomerRewardsListSlice = createSlice({
  name: "getCustomerRewardsListSlice",
  initialState: {
    getCustomerRewardsList: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetCustomerRewardsList: (state) => {
        state.getCustomerRewardsList.loading = false
        state.getCustomerRewardsList.error = false
        state.getCustomerRewardsList.data = []
        state.getCustomerRewardsList.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETCUSTOMERREWARDSLIST.fulfilled, (state, action) => {
      state.getCustomerRewardsList = {
        ...state.getCustomerRewardsList,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETCUSTOMERREWARDSLIST.pending, (state, action) => {
      state.getCustomerRewardsList = {
        ...state.getCustomerRewardsList,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETCUSTOMERREWARDSLIST.rejected, (state, action) => {
      state.getCustomerRewardsList = {
        ...state.getCustomerRewardsList,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getCustomerRewardsListAction = {
    GETCUSTOMERREWARDSLIST,
};

export { getCustomerRewardsListAction };
export default getCustomerRewardsListSlice.reducer;
export const {setInitialStateOfgetCustomerRewardsList} = getCustomerRewardsListSlice.actions
